import React from "react";
import ReactDOM from "react-dom";
import Routes from "./routes/Routes";

import "./static/css/reset.css";

ReactDOM.render(<Routes />, document.getElementById("root"));
